
export default [
    {
        sys:{
            id: "1"
        },
        fields: {
            name: "single economy",
            slug: "single-economy",
            type: "single",
            price: 100,
            size: 200,
            capacity: 1,
            pets: false,
            breakfast: false,
            featured: false,
            description: "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
            extras: [
                "Plush pillows and breathable bed linens",
                "Soft, Oversized bath towels",
                "Full-sized, pH-balanced toiletries",
                "Complimentary refreshments",
                "Adequate safety/security",
                "Internet",
                "Comfortable beds"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: "https://i.ibb.co/98ZYpyL/room-1.jpg"
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: "https://i.ibb.co/fr0kX5k/details-2.jpg"
                        }
                    }
                },
                {
                    fields:{
                        file: {
                            url: "https://i.ibb.co/7bKNMsX/details-3.jpg"
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: "https://i.ibb.co/4d8x4fS/details-4.jpg"
                        }
                    }
                },
            ]
        },

    },
    {
        sys:{
            id: "2"
        },
        fields: {
            name: "single basic",
            slug: "single-basic",
            type: "single",
            price: 150,
            size: 250,
            capacity: 1,
            pets: false,
            breakfast: false,
            featured: false,
            description: "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
            extras: [
                "Plush pillows and breathable bed linens",
                "Soft, Oversized bath towels",
                "Full-sized, pH-balanced toiletries",
                "Complimentary refreshments",
                "Adequate safety/security",
                "Internet",
                "Comfortable beds"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: "https://i.ibb.co/vxsVQ5y/room-2.jpg"
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: "https://i.ibb.co/fr0kX5k/details-2.jpg"
                        }
                    }
                },
                {
                    fields:{
                        file: {
                            url: "https://i.ibb.co/7bKNMsX/details-3.jpg"
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: "https://i.ibb.co/4d8x4fS/details-4.jpg"
                        }
                    }
                },
            ]
        },

    },
    {
        sys:{
            id: "3"
        },
        fields: {
            name: "single standard",
            slug: "single-standard",
            type: "single",
            price: 250,
            size: 300,
            capacity: 1,
            pets: true,
            breakfast: false,
            featured: false,
            description: "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
            extras: [
                "Plush pillows and breathable bed linens",
                "Soft, Oversized bath towels",
                "Full-sized, pH-balanced toiletries",
                "Complimentary refreshments",
                "Adequate safety/security",
                "Internet",
                "Comfortable beds"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: "https://i.ibb.co/zSsykhJ/room-3.jpg"
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: "https://i.ibb.co/fr0kX5k/details-2.jpg"
                        }
                    }
                },
                {
                    fields:{
                        file: {
                            url: "https://i.ibb.co/7bKNMsX/details-3.jpg"
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: "https://i.ibb.co/4d8x4fS/details-4.jpg"
                        }
                    }
                },
            ]
        },

    },
    {
        sys:{
            id: "4"
        },
        fields: {
            name: "single deluxe",
            slug: "single-deluxe",
            type: "single",
            price: 300,
            size: 400,
            capacity: 1,
            pets: true,
            breakfast: true,
            featured: false,
            description: "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
            extras: [
                "Plush pillows and breathable bed linens",
                "Soft, Oversized bath towels",
                "Full-sized, pH-balanced toiletries",
                "Complimentary refreshments",
                "Adequate safety/security",
                "Internet",
                "Comfortable beds"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: "https://i.ibb.co/WWk83qd/room-4.jpg"
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: "https://i.ibb.co/fr0kX5k/details-2.jpg"
                        }
                    }
                },
                {
                    fields:{
                        file: {
                            url: "https://i.ibb.co/7bKNMsX/details-3.jpg"
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: "https://i.ibb.co/4d8x4fS/details-4.jpg"
                        }
                    }
                },
            ]
        },

    },
    {
        sys:{
            id: "5"
        },
        fields: {
            name: "double economy",
            slug: "double-economy",
            type: "double",
            price: 200,
            size: 300,
            capacity: 2,
            pets: false,
            breakfast: false,
            featured: false,
            description: "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
            extras: [
                "Plush pillows and breathable bed linens",
                "Soft, Oversized bath towels",
                "Full-sized, pH-balanced toiletries",
                "Complimentary refreshments",
                "Adequate safety/security",
                "Internet",
                "Comfortable beds"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: "https://i.ibb.co/XkpzBrb/room-5.jpg"
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: "https://i.ibb.co/fr0kX5k/details-2.jpg"
                        }
                    }
                },
                {
                    fields:{
                        file: {
                            url: "https://i.ibb.co/7bKNMsX/details-3.jpg"
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: "https://i.ibb.co/4d8x4fS/details-4.jpg"
                        }
                    }
                },
            ]
        },

    },
    {
        sys: {
          id: "6"
        },
        fields: {
          name: "double basic",
          slug: "double-basic",
          type: "double",
          price: 250,
          size: 350,
          capacity: 2,
          pets: false,
          breakfast: false,
          featured: false,
          description:
            "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
          extras: [
            "Plush pillows and breathable bed linens",
            "Soft, oversized bath towels",
            "Full-sized, pH-balanced toiletries",
            "Complimentary refreshments",
            "Adequate safety/security",
            "Internet",
            "Comfortable beds"
          ],
          images: [
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/Jj6yrVB/room-6.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/fr0kX5k/details-2.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/7bKNMsX/details-3.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/4d8x4fS/details-4.jpg"
                }
              }
            }
          ]
        }
      },
      {
        sys: {
          id: "7"
        },
        fields: {
          name: "double standard",
          slug: "double-standard",
          type: "double",
          price: 300,
          size: 400,
          capacity: 2,
          pets: true,
          breakfast: false,
          featured: false,
          description:
            "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
          extras: [
            "Plush pillows and breathable bed linens",
            "Soft, oversized bath towels",
            "Full-sized, pH-balanced toiletries",
            "Complimentary refreshments",
            "Adequate safety/security",
            "Internet",
            "Comfortable beds"
          ],
          images: [
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/8s2bYMk/room-7.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/fr0kX5k/details-2.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/7bKNMsX/details-3.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/4d8x4fS/details-4.jpg"
                }
              }
            }
          ]
        }
      },
      {
        sys: {
          id: "8"
        },
        fields: {
          name: "double deluxe",
          slug: "double-deluxe",
          type: "double",
          price: 400,
          size: 500,
          capacity: 2,
          pets: true,
          breakfast: true,
          featured: true,
          description:
            "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
          extras: [
            "Plush pillows and breathable bed linens",
            "Soft, oversized bath towels",
            "Full-sized, pH-balanced toiletries",
            "Complimentary refreshments",
            "Adequate safety/security",
            "Internet",
            "Comfortable beds"
          ],
          images: [
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/Tt3LTV9/room-8.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/fr0kX5k/details-2.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/7bKNMsX/details-3.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/4d8x4fS/details-4.jpg"
                }
              }
            }
          ]
        }
      },
      {
        sys: {
          id: "9"
        },
        fields: {
          name: "family economy",
          slug: "family-economy",
          type: "family",
          price: 300,
          size: 500,
          capacity: 3,
          pets: false,
          breakfast: false,
          featured: false,
          description:
            "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
          extras: [
            "Plush pillows and breathable bed linens",
            "Soft, oversized bath towels",
            "Full-sized, pH-balanced toiletries",
            "Complimentary refreshments",
            "Adequate safety/security",
            "Internet",
            "Comfortable beds"
          ],
          images: [
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/KhCVBb1/room-9.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/fr0kX5k/details-2.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/7bKNMsX/details-3.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/4d8x4fS/details-4.jpg"
                }
              }
            }
          ]
        }
      },
      {
        sys: {
          id: "10"
        },
        fields: {
          name: "family basic",
          slug: "family-basic",
          type: "family",
          price: 350,
          size: 550,
          capacity: 4,
          pets: false,
          breakfast: false,
          featured: false,
          description:
            "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
          extras: [
            "Plush pillows and breathable bed linens",
            "Soft, oversized bath towels",
            "Full-sized, pH-balanced toiletries",
            "Complimentary refreshments",
            "Adequate safety/security",
            "Internet",
            "Comfortable beds"
          ],
          images: [
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/g4YBxxd/room-10.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/fr0kX5k/details-2.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/7bKNMsX/details-3.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/4d8x4fS/details-4.jpg"
                }
              }
            }
          ]
        }
      },
      {
        sys: {
          id: "11"
        },
        fields: {
          name: "family standard",
          slug: "family-standard",
          type: "family",
          price: 400,
          size: 600,
          capacity: 5,
          pets: true,
          breakfast: false,
          featured: false,
          description:
            "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
          extras: [
            "Plush pillows and breathable bed linens",
            "Soft, oversized bath towels",
            "Full-sized, pH-balanced toiletries",
            "Complimentary refreshments",
            "Adequate safety/security",
            "Internet",
            "Comfortable beds"
          ],
          images: [
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/gZgBq7J/room-11.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/fr0kX5k/details-2.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/7bKNMsX/details-3.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/4d8x4fS/details-4.jpg"
                }
              }
            }
          ]
        }
      },
      {
        sys: {
          id: "12"
        },
        fields: {
          name: "family deluxe",
          slug: "family-deluxe",
          type: "family",
          price: 500,
          size: 700,
          capacity: 6,
          pets: true,
          breakfast: true,
          featured: true,
          description:
            "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
          extras: [
            "Plush pillows and breathable bed linens",
            "Soft, oversized bath towels",
            "Full-sized, pH-balanced toiletries",
            "Complimentary refreshments",
            "Adequate safety/security",
            "Internet",
            "Comfortable beds"
          ],
          images: [
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/nMNz6dn/room-12.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/fr0kX5k/details-2.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/7bKNMsX/details-3.jpg"
                }
              }
            }
          ]
        }
      },
      {
        sys: {
          id: "13"
        },
        fields: {
          name: "presidential",
          slug: "presidential-room",
          type: "presidential",
          price: 600,
          size: 1000,
          capacity: 10,
          pets: true,
          breakfast: true,
          featured: true,
          description:
            "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
          extras: [
            "Plush pillows and breathable bed linens",
            "Soft, oversized bath towels",
            "Full-sized, pH-balanced toiletries",
            "Complimentary refreshments",
            "Adequate safety/security",
            "Internet",
            "Comfortable beds"
          ],
          images: [
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/X2v12z4/details-1.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/fr0kX5k/details-2.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/7bKNMsX/details-3.jpg"
                }
              }
            },
            {
              fields: {
                file: {
                  url: "https://i.ibb.co/4d8x4fS/details-4.jpg"
                }
              }
            }     
          ]
        }
      }
]